import { Button, CircularProgress } from "@mui/material";
import React from "react";

import styles from "../ProfilePage.module.scss";

interface BillingStatusBannerProps {
  state: "failed" | "cancelled";
  loading?: boolean;
  onPay: () => void;
  onResume: () => void;
}

const buttonSx = {
  background: "transparent",
  border: "1px solid #5a4a2a",
  borderRadius: "999px",
  color: "#e09a3a",
  fontSize: "13px",
  fontWeight: 500,
  padding: "6px 16px",
  textTransform: "none",
  whiteSpace: "nowrap",
  "&:hover": { background: "#2a1f0a" },
  "&.Mui-disabled": {
    background: "transparent",
    border: "1px solid #5a4a2a",
    color: "#e09a3a",
    opacity: 0.7,
  },
} as const;

const BillingStatusBanner: React.FC<BillingStatusBannerProps> = ({
  state,
  loading,
  onPay,
  onResume,
}) => (
  <div className={styles.developerFreeTierWarning}>
    <span>⚠</span>
    {state === "failed" ? (
      <>
        <span>
          Your last payment for API usage failed, so the API is paused. Complete
          the payment to resume access.
        </span>
        <Button disabled={loading} onClick={onPay} sx={buttonSx}>
          {loading ? (
            <CircularProgress size={14} sx={{ color: "#e09a3a" }} />
          ) : (
            "Pay now"
          )}
        </Button>
      </>
    ) : (
      <>
        <span>
          Your Autopilot API is paused because your Slapshot plan was cancelled.
          Resume to start using the developer APIs again.
        </span>
        <Button disabled={loading} onClick={onResume} sx={buttonSx}>
          {loading ? (
            <CircularProgress size={14} sx={{ color: "#e09a3a" }} />
          ) : (
            "Resume API"
          )}
        </Button>
      </>
    )}
  </div>
);

export default BillingStatusBanner;
